import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Sidepanel from './_sidepanel/component';
import Popup from './_popup/component';
import store from '@utils/store';

const Modal = ({ initModal }) => {
  const [location, setLocation] = useState('');
  const [variant, setVariant] = useState('');
  const [style, setStyle] = useState({});
  const [persist, setPersist] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [component, setComponent] = useState(null);
  const [title, setTitle] = useState('');
  const [classNames, setClassNames] = useState('');

  const modalRef = useRef({});

  useEffect(() => {
    if (initModal) {
      initModal(modalRef.current);
    }
  }, [initModal]);

  const toggleScroll = (disable) => {
    document.documentElement.style.overflowY = disable ? 'hidden' : '';
  };

  const removeComponentFromModal = () => {
    const animationDuration = variant === 'popup' ? 0 : 300;
    setTimeout(() => {
      setComponent(null);
      setTitle('');
      setClassNames('');
    }, animationDuration);
  };

  const closeModal = (e) => {
    e && e.preventDefault();
    setToggled(false);
    toggleScroll(false);
    if (!persist) removeComponentFromModal();
    store.events.publish('closeModal');
  };

  const openModal = (newVariant = '', newLocation = '', attrs = {}, isToggled = true) => {
    const newPersist = attrs?.persist || false;

    let newComponent = attrs.component;
    if (!newComponent && attrs.text) {
      newComponent = <p>{attrs.text}</p>;
    }

    setVariant(newVariant);
    setLocation(newLocation);
    setStyle(attrs.style || {});
    setPersist(newPersist);
    setToggled(isToggled);
    setComponent(newComponent || null);
    setTitle(attrs.title || '');
    setClassNames(attrs.classNames || '');

    toggleScroll(isToggled);
  };

  modalRef.current = { openModal, closeModal, toggleScroll };

  const getModalVariant = () => {
    const transMap = {
      default: Sidepanel,
      sidepanel: Sidepanel,
      popup: Popup,
    };
    return transMap[variant] || transMap.default;
  };

  const ModalVariant = getModalVariant();

  return (
    <ModalVariant
      location={location}
      variant={variant}
      style={style}
      persist={persist}
      toggled={toggled}
      component={component}
      title={title}
      classNames={classNames}
      closeModal={closeModal}
    />
  );
};

Modal.propTypes = {
  initModal: PropTypes.func,
};

export default Modal;
